import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';

export default React.memo(function LinkFulfilled({ className = '', children, external, ...props }) {

  const Element = useMemo(() => external ? ({ children, to, ...props }) => <a rel={'noopener noreferrer'} href={to} {...props}>{children}</a> : Link, [external]);

  return (
    <Element {...props}
             // className={`rounded-2xl flex items-center justify-center py-4 overflow-hidden btn__outlined after:absolute after:inset-0 after:z-[0] [&>*]:z-10 after:transition-all after:bg-gradient ${className}`}>
             className={`rounded-2xl flex items-center justify-center py-4 overflow-hidden bg-brandedColor after:z-[0] [&>*]:z-10  ${className}`}>
      {children}
    </Element>
  );
})
